import React, { CSSProperties } from 'react';

interface IFrameProps {
    src: string;
    style?: CSSProperties;
}

const IFrame: React.FC<IFrameProps> = ({ src, style }) => {
    const defaultStyle: CSSProperties = {
        width: '100%',
        height: '100%',
        border: 'none',
        backgroundColor: 'white',
        overflow: 'hidden'
    };

    const combinedStyles: CSSProperties = { ...defaultStyle, ...style };

    return (
        <iframe
            src={src}
            style={combinedStyles}
            className='no-select'
        />
    );
};

export default IFrame;
